import React from "react";

export default function ThankYou() {
  return (
    <main className="flex items-start md:items-center p-2 justify-center w-screen h-screen max-w-full max-h-full md:p-24 select-none md:bg-dark/5">
      <div className="flex absolute top-0 pt-2 visible md:hidden w-full justify-center items-center">
        <img
          className="object-fill h-10 mr-2"
          alt="logo"
          loading="eager"
          src={
            "https://firebasestorage.googleapis.com/v0/b/fir-forever-midwest.appspot.com/o/Logo.svg?alt=media&token=77e7cd03-1f70-4549-996c-b099a8cfe6ae"
          }
        />
        <h1 className="text-4xl text-dark/90  font-bold">
          <span className="text-primary">Art</span>Zipper.com
        </h1>
      </div>
      {/* Background Image */}

      {/* ... for corner, TODO: have licensing and cookies agreement pop up after clicked 
    <div className="absolute bottom-0 right-0 p-2 text-4xl font-bold text-primary 800 transition-colors cursor-pointer hover:text-primary 600">
      ...
    </div>*/}

      <div className="z-10 md:bg-white rounded-md md:shadow-lg p-2 flex-col flex items-center  justify-center font-mono text-sm md:w-96 w-full">
        {/* Logo - Todo, make not draggable */}

        {/* Subscribe Form - TODO: have subscribe form send to firebase */}
        <div className="flex flex-col pb-1 items-center justify-center h-full w-full md:w-96 max-w-screen">
          <div className="flex md:visible invisible pt-3 w-full justify-center items-center">
            <img
              className="object-fill h-10 mr-2"
              alt="logo"
              loading="eager"
              src={
                "https://firebasestorage.googleapis.com/v0/b/fir-forever-midwest.appspot.com/o/Logo.svg?alt=media&token=77e7cd03-1f70-4549-996c-b099a8cfe6ae"
              }
            />
            <h1 className="text-4xl text-dark  font-bold">
              <span className="text-primary">Art</span>Zipper.com
            </h1>
          </div>
        </div>
        <h1 className="text-2xl font-semibold text-primary ">Thank you!</h1>
        <p className="text-base w-full text-center text-dark/50">
          {
            "You're all set. You'll receive details and updates about ArtZipper.com as they happen."
          }
        </p>
      </div>
    </main>
  );
}
